module.exports = __webpack_public_path__ + "img/crop_info_left_left.3b9134bf.png";